"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RemoveBrandingBanner = _interopRequireDefault(require("ui-addon-upgrades/_core/lockedFeature/RemoveBrandingBanner"));

var _connectUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var LOCKED_FEATURE = _sources.sourceKeys.LOCKED_FEATURE;

var _default = (0, _connectUpgradeData.default)(_RemoveBrandingBanner.default, LOCKED_FEATURE);

exports.default = _default;
module.exports = exports.default;